import { getNumberFormatter } from "./intl";

interface BaseOptions {
  locale: MatchiLocale;
  number: number;
  currency: string;
}

export const formatCurrency = ({ locale, number, currency }: BaseOptions) => {
  const formatter = getNumberFormatter(locale, {
    style: "currency",
    currency,
  });

  // Replace non-breaking space with regular spaces
  return formatter.format(number).replace(/\u00A0/g, " ");
};
